export default __webpack_public_path__ + "c6df601d0934c3de71b4f6e50f4c88c2.png";